// extracted by mini-css-extract-plugin
module.exports = {"instructor_name":"InstructorName_instructor_name__3dmoy"};